<section class="chat-list">
  <header class="header">
    <button type="button" class="user-img" (click)="openProfile()" aria-label="Abrir mi perfil">
      <img
        src="assets/images/soporte_bcp.png"
        [alt]="currentUser()?.fullName || 'Mi avatar'"
      />
    </button>
    <nav class="nav" aria-label="Acciones de chat">
      <button type="button" class="nav-btn status" aria-label="Estados" title="Próximamente" disabled>
        <svg viewBox="0 0 24 24" width="24" height="24" fill="currentColor" aria-hidden="true"><path d="M12 20q-1.65 0-3.1-.625-1.45-.625-2.55-1.725-1.1-1.1-1.725-2.55Q4 13.65 4 12t.625-3.1q.625-1.45 1.725-2.55 1.1-1.1 2.55-1.725Q10.35 4 12 4t3.1.625q1.45.625 2.55 1.725 1.1 1.1 1.725 2.55Q20 10.35 20 12t-.625 3.1q-.625 1.45-1.725 2.55-1.1 1.1-2.55 1.725Q13.65 20 12 20Z" opacity=".3"/><path d="M12 22q-2.05 0-3.875-.788-1.825-.787-3.187-2.15-1.363-1.362-2.15-3.187Q2 14.05 2 12t.788-3.875q.787-1.825 2.15-3.187 1.362-1.363 3.187-2.15Q9.95 2 12 2t3.875.788q1.825.787 3.187 2.15 1.363 1.362 2.15 3.187Q22 9.95 22 12t-.788 3.875q-.787 1.825-2.15 3.187-1.362 1.363-3.187 2.15Q14.05 22 12 22Zm0-2q3.35 0 5.675-2.325Q20 15.35 20 12q0-3.35-2.325-5.675Q15.35 4 12 4 8.65 4 6.325 6.325 4 8.65 4 12q0 3.35 2.325 5.675Q8.65 20 12 20Z"/></svg>
      </button>
      <button type="button" class="nav-btn new-chat" (click)="openNewChat()" aria-label="Nuevo chat">
        <svg viewBox="0 0 24 24" width="24" height="24" fill="currentColor" aria-hidden="true"><path d="M19 13h-6v6h-2v-6H5v-2h6V5h2v6h6v2z"/></svg>
      </button>
      <button type="button" class="nav-btn menu" aria-label="Menú" title="Próximamente" disabled>
        <svg viewBox="0 0 24 24" width="24" height="24" fill="currentColor" aria-hidden="true"><circle cx="12" cy="5" r="2"/><circle cx="12" cy="12" r="2"/><circle cx="12" cy="19" r="2"/></svg>
      </button>
      <button type="button" class="nav-btn logout" (click)="logout()" aria-label="Cerrar sesion">
        <svg width="24" height="24" viewBox="0 0 24 24" fill="currentColor" aria-hidden="true">
          <path d="M16 17v-3H9v-4h7V7l5 5-5 5M14 2a2 2 0 012 2v2h-2V4H5v16h9v-2h2v2a2 2 0 01-2 2H5a2 2 0 01-2-2V4a2 2 0 012-2h9z"/>
        </svg>
      </button>
    </nav>
  </header>

  <div class="search-container">
    <label class="search">
      <span class="search-icon" aria-hidden="true">
        <svg viewBox="0 0 24 24" width="20" height="20" fill="currentColor"><path d="M15.5 14h-.79l-.28-.27A6.471 6.471 0 0 0 16 9.5 6.5 6.5 0 1 0 9.5 16c1.61 0 3.09-.59 4.23-1.57l.27.28v.79l5 4.99L20.49 19l-4.99-5zm-6 0C7.01 14 5 11.99 5 9.5S7.01 5 9.5 5 14 7.01 14 9.5 11.99 14 9.5 14z"/></svg>
      </span>
      <input
        [ngModel]="searchVal"
        (ngModelChange)="onSearchInput($event)"
        type="search"
        placeholder="Buscar o iniciar nuevo chat"
        aria-label="Buscar chats"
      />
    </label>
    <button type="button" class="icon unread-chat-filter" aria-label="Filtrar no leídos" title="Próximamente" disabled>
      <svg viewBox="0 0 24 24" width="20" height="20" fill="currentColor" aria-hidden="true"><path d="M10 18h4v-2h-4v2zM3 6v2h18V6H3zm3 7h12v-2H6v2z"/></svg>
    </button>
  </div>

  <div class="list" role="list" aria-label="Lista de chats">
    @if (loading() && !chats().length) {
      @for (s of skeletonRows; track $index) {
        <div class="skeleton-row" aria-hidden="true">
          <div class="skeleton-row__avatar"></div>
          <div class="skeleton-row__body">
            <div class="skeleton-row__line skeleton-row__line--title"></div>
            <div class="skeleton-row__line skeleton-row__line--subtitle"></div>
          </div>
        </div>
      }
    } @else if (!chats().length) {
      <p class="no-chats-msg">Aun no tienes chats. Toca el icono de Nuevo chat para empezar.</p>
    } @else {
      @for (chat of chats(); track chat.id) {
        <app-chat-preview
          [chat]="chat"
          class="chat-row"
          role="listitem"
          tabindex="0"
          [class.selected]="selectedId() === chat.id"
          [attr.aria-current]="selectedId() === chat.id ? 'true' : null"
          (click)="selectChat(chat.id)"
          (keydown.enter)="selectChat(chat.id)"
          (keydown.space)="$event.preventDefault(); selectChat(chat.id)"
        />
      }
    }
  </div>
</section>
